import {FormFieldConfig} from '@/components/Forms/CommonRegistrationForm/CommonRegistrationForm';
import {
  GetFormFieldsProps,
  GetHubspotFormDataForSubmissionProps,
} from '@/components/Forms/CommonRegistrationForm/CommonRegistrationPage';
import {tocaLocations, tocaLocationsWithoutWorkingMboSiteId} from '@/constants/locations';
import {TrackingStrings} from '@/redux/slices/fkoFormData';
import {isValidPhoneNumber} from '@/utils/utils';
import * as yup from 'yup';
import {FreeTrialProgram} from './fko-utils';

export type FreePickupAndLeaguesUrlParams = {
  [key in TrackingStrings]?: string;
} & {
  locations__drop_down_?: string;
  source?: string;
};

export const HUBSPOT_LEAGUES_FIELD_VALUE = 'Leagues';
export const HUBSPOT_PICKUP_FIELD_VALUE = 'Open Play';

export const getFreePickupAndLeaguesFormDataForSubmission = ({
  validLocation,
  urlParams,
  formData,
  programName,
}: GetHubspotFormDataForSubmissionProps<FreePickupAndLeaguesUrlParams>): Record<string, string> => {
  const {locations__drop_down_, source, ...otherUrlParams} = urlParams;

  const interestedIn =
    programName === FreeTrialProgram.PICKUP_SOCCER ? HUBSPOT_PICKUP_FIELD_VALUE : HUBSPOT_LEAGUES_FIELD_VALUE;
  const selectedLocation = [...tocaLocations, ...tocaLocationsWithoutWorkingMboSiteId].find(
    (location) => location.siteId === formData.location
  );
  const locationHubspotName = selectedLocation?.hubspotName;

  const hubSpotData: Record<string, string> = {
    ...otherUrlParams,
    firstname: formData.firstname,
    lastname: formData.lastname,
    email: formData.email,
    phone: formData.phone,
    locations__drop_down_: validLocation || locationHubspotName || '',
    i_am_interested_in___: interestedIn,
  };

  if (source) {
    hubSpotData.source = source;
  }

  return hubSpotData;
};

export const getFreePickupAndLeaguesFormFields = ({
  validLocation,
  locationsAllowed,
}: GetFormFieldsProps): FormFieldConfig[] => {
  const fields: FormFieldConfig[] = [
    {
      name: 'firstname',
      type: 'text',
      placeholder: 'First Name',
      validation: yup.string().trim().required('Please enter your first name'),
    },
    {
      name: 'lastname',
      type: 'text',
      placeholder: 'Last Name',
      validation: yup.string().trim().required('Please enter your last name'),
    },
    {
      name: 'email',
      type: 'email',
      placeholder: 'Email',
      validation: yup
        .string()
        .email('Email is invalid')
        .required('Email is required')
        .matches(/^[^+]+$/, 'Email must not contain "+" signs'),
    },
    {
      name: 'phone',
      type: 'tel',
      placeholder: 'Phone number',
      validation: yup
        .string()
        .required('Phone number is required')
        .test('valid-phone', 'Must be a valid phone number', (value) => !value || isValidPhoneNumber(value)),
    },
  ];

  if (!validLocation) {
    fields.push({
      name: 'location',
      type: 'select',
      placeholder: 'Select Location',
      validation: yup
        .string()
        .required('Please select a location')
        .notOneOf(['disabled-placeholder'], 'Please choose a location'),
      options: locationsAllowed.map((location) => ({
        id: location,
        value: location,
        displayValue: location,
      })),
    });
  }

  return fields;
};
